import {type ReactNode} from "react";
import {Link} from "react-router-dom";
import {logout, type AccountProfile, type I18nKey} from "@zaaaz/shared";
import {useI18n} from "./I18nProvider";
import {accountTabPath, paths, type AccountTabId} from "@/lib/paths";

const NAV: {tab: AccountTabId; label: I18nKey; icon: string; influencerOnly?: boolean}[] = [
  {tab: "", label: "Orders", icon: "fa-shopping-bag"},
  {tab: "retur", label: "Returns", icon: "fa-retweet"},
  {tab: "informatii", label: "Profile", icon: "fa-user"},
  {tab: "retea", label: "Your network", icon: "fa-users"},
  {tab: "influencer", label: "Influencer", icon: "fa-star", influencerOnly: true},
  {tab: "adrese", label: "Addresses", icon: "fa-map-marker"},
  {tab: "firme", label: "Billing companies", icon: "fa-building"},
  {tab: "notificari", label: "Notifications", icon: "fa-bell"}
];

export function AccountChrome({
  profile,
  activeTab,
  title,
  subtitle,
  backTo,
  onLogout,
  children
}: {
  profile: AccountProfile;
  activeTab: AccountTabId;
  title?: string;
  subtitle?: string;
  backTo?: {label: string; href: string};
  onLogout: (e: React.MouseEvent) => void;
  children: ReactNode;
}) {
  const {t} = useI18n();
  const active = activeTab || "";
  const showPageHead = Boolean(title || backTo);
  return (
    <div className="cc-account">
      <div className="cc-account__layout">
        <aside className="cc-account__sidebar">
          <div className="cc-account__profile">
            <span className="cc-account__avatar">{profile.nume.charAt(0).toUpperCase()}</span>
            <span className="cc-account__name">{profile.nume}</span>
            <span className="cc-account__since">{t("Member since")} {profile.memberSince}</span>
            <a href="#" className="cc-account__logout anim" onClick={onLogout}><i className="fa fa-sign-out" /> {t("Log out")}</a>
          </div>
          <nav className="cc-account__nav" aria-label={t("Account")}>
            {NAV.filter((item) => !item.influencerOnly || profile.influencer).map((item) => (
              <Link key={item.tab || "orders"} to={accountTabPath(item.tab)} className={`cc-account__navLink anim${active === item.tab ? " isActive" : ""}`}>
                <i className={`fa ${item.icon} cc-account__navIcon`} aria-hidden="true" />
                {t(item.label)}
              </Link>
            ))}
          </nav>
        </aside>
        <div className="cc-account__content">
          {showPageHead ? (
            <header className="cc-account__pageHead">
              {backTo ? (
                <Link to={backTo.href} className="cc-account__back anim">
                  <i className="fa fa-angle-left" aria-hidden="true" /> {backTo.label}
                </Link>
              ) : null}
              {title ? <h1 className="cc-account__pageTitle">{title}</h1> : null}
              {subtitle ? <p className="cc-account__pageSub">{subtitle}</p> : null}
            </header>
          ) : null}
          {children}
        </div>
      </div>
    </div>
  );
}

export async function accountLogout(navigate: (path: string) => void) {
  await logout();
  navigate(paths.login);
}
